import * as frontCommonApi from "@/controller/frontCommon.js";

const common = {
  state: {
    loading: false,
    obsUploadData: {},
    isShowDialogDownload: false, // 展示下载弹窗
  },
  mutations: {
    SET_LOADING: (state, loading) => {
      // eslint-disable-next-line no-param-reassign
      state.loading = loading;
    },
    SET_PICI_GOODS_NUM: (state, num) => {
      // eslint-disable-next-line no-param-reassign
      state.pici_goods_num = num ?? 0;
    },
    SET_OBS_UPLOAD_DATA: (state, data) => {
      // eslint-disable-next-line no-param-reassign
      state.obsUploadData = data;
    },
    TOGGLE_DOWNLOAD_DIALOG: (state, show) => {
      // eslint-disable-next-line no-param-reassign
      state.isShowDialogDownload = show;
    },
  },
  actions: {
    setLoading({ commit }, loading) {
      commit("SET_LOADING", loading);
    },
    async getObsUploadData({ commit }) {
      const obsUploadData = await frontCommonApi.getObsUploadData();
      commit("SET_OBS_UPLOAD_DATA", obsUploadData);
    },
  },
  getters: {
    obsUploadData: (state) => state.obsUploadData,
    isShowDialogDownload: (state) => state.isShowDialogDownload,
  },
};
export default common;



// WEBPACK FOOTER //
// ./src/store/modules/common.js